import Utils from '.';
import { IOrganization } from '../common/types/organisation';
import { signOut } from '../services/authService';

export function filterOrganization<T extends { id: string }>(
  data: T[],
  organization: IOrganization
): T[] {
  return data.filter((d) => {
    if (organization && organization.taxonomy?.value?.length && d.id) {
      return organization.taxonomy.value.includes(d.id);
    } else {
      return true;
    }
  });
}

export function prepareDataTaxonomy<T extends { id: string; name: string }>(
  data: T[],
  organization: IOrganization
): T[] {
  return filterOrganization(data, organization);
}
export function sortArrayObjects<T>(key: keyof T, data: T[]): T[] {
  return data.sort((a, b) => {
    const regex = /(\D*)(\d*\.?\d*)/;
    const matchA = (a[key] as string).match(regex);
    const matchB = (b[key] as string).match(regex);

    if (!matchA || !matchB) {
      return 0;
    }

    const textA = matchA[1].trim().toLowerCase();
    const textB = matchB[1].trim().toLowerCase();
    const numA = parseFloat(matchA[2]) || 0;
    const numB = parseFloat(matchB[2]) || 0;

    if (textA !== textB) {
      return textA.localeCompare(textB);
    }

    return numA - numB;
  });
}

export const checkExpiry = () => {
  const expiresIn = Utils.getCookie('expires-in');
  if (expiresIn) {
    const now = new Date();
    const expiryDate = new Date(expiresIn);
    if (now > expiryDate) {
      signOut();
    }
  }
};
